/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerInsuranceType } from './ScreenerInsuranceType';
import {
    ScreenerInsuranceTypeFromJSON,
    ScreenerInsuranceTypeFromJSONTyped,
    ScreenerInsuranceTypeToJSON,
    ScreenerInsuranceTypeToJSONTyped,
} from './ScreenerInsuranceType';

/**
 * 
 * @export
 * @interface MarkPayerAsInnRequest
 */
export interface MarkPayerAsInnRequest {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    insurance_types?: Array<ScreenerInsuranceType>;
}

/**
 * Check if a given object implements the MarkPayerAsInnRequest interface.
 */
export function instanceOfMarkPayerAsInnRequest(value: object): value is MarkPayerAsInnRequest {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    return true;
}

export function MarkPayerAsInnRequestFromJSON(json: any): MarkPayerAsInnRequest {
    return MarkPayerAsInnRequestFromJSONTyped(json, false);
}

export function MarkPayerAsInnRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkPayerAsInnRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'insurance_types': json['insurance_types'] == null ? undefined : ((json['insurance_types'] as Array<any>).map(ScreenerInsuranceTypeFromJSON)),
    };
}

export function MarkPayerAsInnRequestToJSON(json: any): MarkPayerAsInnRequest {
    return MarkPayerAsInnRequestToJSONTyped(json, false);
}

export function MarkPayerAsInnRequestToJSONTyped(value?: MarkPayerAsInnRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'insurance_types': value['insurance_types'] == null ? undefined : ((value['insurance_types'] as Array<any>).map(ScreenerInsuranceTypeToJSON)),
    };
}

